/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import { Box, Card, CardActionArea, CardContent, Divider, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

export interface ContentCardProps {
    title: string;
    icon: JSX.Element;
    description: string;
    url: string;
    targetBlank?: boolean;
    unavailable?: boolean;
}

const ContentCard = (props: ContentCardProps) => {
    const { title, icon, description, url, targetBlank, unavailable = false } = props;

    let targetBlankComp = targetBlank ?? false;

    const navigate = useNavigate();

    return (
        <Card component={Paper} sx={{ opacity: unavailable ? 0.35 : 1.0 }}>
            <CardActionArea
                disabled={unavailable}
                onClick={() => {
                    if (targetBlankComp) {
                        window.open(url, "_blank", "noreferrer");
                    } else {
                        navigate(url);
                    }
                }}
            >
                <CardContent>
                    <Stack direction="row" justifyContent="space-between">
                        <Stack direction={"column"} justifyContent={"center"} marginRight={4}>
                            {icon}
                        </Stack>
                        <Typography fontWeight="bold" fontSize={20}>
                            {title}
                        </Typography>
                    </Stack>
                    <Box sx={{ mb: 1 }} />
                    <Divider variant="inset" />
                    <Box sx={{ mb: 2 }} />
                    <Typography height="12vh" flexWrap="wrap">
                        {description}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default ContentCard;
